import { Link, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/auth/AuthContext'
import { getAppConfig } from '@/config/env'

import styles from './AppShell.module.css'

/**
 * Site chrome with flyer-inspired brand bar.
 */
export function AppShell() {
  const { appName } = getAppConfig()
  const brand = appName.replace(/\s+Market.*/i, '').trim() || 'Oikos'
  const { pathname } = useLocation()
  const { isAuthenticated, isAdmin, logout } = useAuth()
  const showHome = pathname !== '/'
  const showCalendar = pathname !== '/calendar'
  const showVendorArea = !isAdmin
  const showAdminArea = !isAuthenticated || isAdmin

  return (
    <div className={styles.shell}>
      <a className={styles.skipLink} href="#main-content">
        Skip to content
      </a>
      <header className={styles.topBar}>
        <Link className={styles.brandLink} to="/">
          {brand.toUpperCase()} <span>MARKET</span>
        </Link>
        <nav className={styles.nav} aria-label="Primary">
          {showHome ? <Link to="/">Home</Link> : null}
          {showCalendar ? <Link to="/calendar">Calendar</Link> : null}
          {!isAuthenticated ? <Link to="/signup">Vendor signup</Link> : null}
          {showVendorArea ? <Link to="/vendor">Vendor area</Link> : null}
          {showAdminArea ? <Link to="/admin">Admin area</Link> : null}
          {isAuthenticated ? <Link to="/profile">Profile</Link> : null}
          {isAuthenticated ? (
            <button type="button" className={styles.navAuth} onClick={logout}>
              Sign out
            </button>
          ) : (
            <Link className={styles.navAuth} to="/login">
              Sign in
            </Link>
          )}
        </nav>
      </header>
      <main id="main-content" className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
